import { createContext, useContext, useEffect, useState } from "react";
import { useGetBranches } from "../services/branch";

// One page holds every branch; the list scrolls rather than paginates.
const BRANCH_PAGE_SIZE = 50;

export const MapContext = createContext();
export const useMapContext = () => useContext(MapContext);
const MapProvider = ({ children }) => {
  const [fragment, setfragment] = useState(0);
  const [search, setSearch] = useState("");
  const [currentPosition, setCurrentPosition] = useState(null);
  const [{ data, loading, error }, fetchBranches] = useGetBranches();
  const [menuBoxBgTran, setmenuBoxBgTran] = useState(true);

  let state = {
    fragment,
    search,
    currentPosition,
    data,
    menuBoxBgTran,
  };
  let action = {
    setfragment: (fragment) => setfragment(fragment),
    setSearch: (search) => setSearch(search),
    setCurrentPosition: (currentPosition) =>
      setCurrentPosition(currentPosition),
    setmenuBoxBgTran: (menuBoxBgTran) => setmenuBoxBgTran(menuBoxBgTran),
    refetch: (params) =>
      fetchBranches({
        params: {
          current_latitude: params.current_latitude || currentPosition?.[0],
          current_longtitude: params.current_longtitude || currentPosition?.[1],
          // is_available: true,
          page: params.page || 1,
          // Every branch the shop runs fits on one page: the list is sorted
          // by distance and scrolls, and a page of five quietly hid the
          // branches that opened after it was written.
          limit: params.limit || BRANCH_PAGE_SIZE,
        },
      }).catch((err) => console.error),
  };
  // Fetch once on mount
  useEffect(() => {
    fetchBranches({
      params: {
        page: 1,
        limit: BRANCH_PAGE_SIZE,
      },
    }).catch((err) => {
      // Ignore canceled requests (happens when component unmounts)
      if (err?.canceled) return;
      console.error(err);
    });
  }, []);

  // Re-fetch when position is available (to sort by distance)
  useEffect(() => {
    if (search === "" && currentPosition) {
      fetchBranches({
        params: {
          current_latitude: currentPosition?.[0],
          current_longtitude: currentPosition?.[1],
          // is_available: true,
          page: 1,
          limit: BRANCH_PAGE_SIZE,
        },
      }).catch((err) => {
        // Ignore canceled requests (happens when component unmounts)
        if (err?.canceled) return;
        console.error(err);
      });
    }
  }, [currentPosition, search]);
  return (
    <MapContext.Provider value={{ ...action, ...state }}>
      {children}
    </MapContext.Provider>
  );
};

export default MapProvider;
